<template>
  <div>
    <transition name="overlay-fade">
      <div class="overlay-message" v-show="sendOk">
        <p>
          Uw bericht is verzonden.
        </p>
      </div>
    </transition>

    <div class="dialog-content">
      <p>
        Wilt u meer informatie over het toevoegen van uw eigen ontwerpen? Vul
        hieronder uw gegevens in en wij nemen contact met u op.
      </p>
      <form
        name="callBackForm"
        method="post"
        action="/callBack"
        @submit.prevent="sendForm()"
      >
        <div>
          <label for="name">Naam</label>
          <input
            id="name"
            type="text"
            placeholder="Uw naam"
            v-model="contact.userInfo.name"
            maxlength="128"
            @input="v$.contact.userInfo.name.$touch()"
            :class="{
              invalid:
                v$.contact.userInfo.name.$invalid &&
                v$.contact.userInfo.name.$dirty
            }"
          />
        </div>
        <div>
          <label for="email">E-mailadres</label>
          <input
            id="email"
            type="email"
            placeholder="Uw e-mailadres"
            v-model="contact.userInfo.email"
            maxlength="128"
            @input="v$.contact.userInfo.email.$touch()"
            :class="{
              invalid:
                v$.contact.userInfo.email.$invalid &&
                v$.contact.userInfo.email.$dirty
            }"
          />
        </div>

        <div>
          <label for="message">Bericht</label>
          <textarea
            id="message"
            v-model="contact.message"
            placeholder="Typ hier uw bericht"
            @input="v$.contact.message.$touch()"
            :class="{
              invalid: v$.contact.message.$invalid && v$.contact.message.$dirty
            }"
          ></textarea>
        </div>

        <div class="button-holder">
          <button
            class="pill-button secondary"
            type="button"
            v-show="!sending"
            @click="$emit('close')"
          >
            Annuleren
          </button>
          <button
            id="confirm-button"
            class="pill-button"
            type="submit"
            v-show="!sending"
            :disabled="v$.$invalid"
          >
            Verzenden
          </button>
          <bouncing-spinner
            class="spinner-ct"
            v-show="sending"
          ></bouncing-spinner>
        </div>

        <section class="error" v-show="sendError">
          <span class="error-text"
            >Er is een fout opgetreden bij het verzenden van uw bericht, probeer
            het later nogmaals.</span
          >
        </section>
      </form>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

import { sendMail } from '@/api/api'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      sendOk: false,
      errorMessage: '',
      sending: false,
      sendError: false,
      notifyMe: false,
      contact: {
        title: 'Verzoek voor meer informatie eigen stickers en borden',
        subject: 'Verzoek voor meer informatie eigen stickers en borden',
        userInfo: {
          email: '',
          name: ''
        },
        message: '',
        to: 'camiel@rijnja.nl'
      }
    }
  },
  validations: {
    contact: {
      userInfo: {
        email: {
          email,
          required
        },
        name: {
          required
        }
      },
      message: {
        required
      }
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  methods: {
    sendForm() {
      let contact = { ...this.contact }

      if (this.notifyMe) {
        contact.message =
          contact.message + '\n\n Ik wil graag op de hoogte worden gehouden.'
      }

      if (this.printStoreStore.currentCollectionName) {
        contact.message =
          contact.message +
          '\n\n Huidige collectie: ' +
          this.printStoreStore.currentCollectionName
      }

      contact.message += '\n\n Thema: ' + this.rootStore.theme.mainThemeName

      this.sending = true
      sendMail(contact).then((val) => {
        //this.sending = false

        if (val === true) {
          this.sendOk = true

          setTimeout(() => {
            //this.sendOk = false
            this.$emit('close')
          }, 1500)
        } else {
          this.sendError = true
        }
      })
    },
    setNotifyMe() {
      this.notifyMe = !this.notifyMe
    }
  },
  created() {
    if (this.rootStore?.user) {
      this.contact.userInfo.email = this.rootStore.user.username || ''
      this.contact.userInfo.name = this.rootStore.user.name || ''
    }
  }
  /* created() {
    //this.contact.userInfo.name = this.rootStore.user.name
  } */
}
</script>
<style lang="scss" scoped>
textarea {
  height: 100px;
  border: 1px solid #bfbfbf;
  margin-bottom: 15px;
  padding: 10px;
  background: #ececec;
  border-radius: 17px;
  border: 1px solid #ececec;
  transition: border-color 0.25s;
  width: 100%;
  margin-top: 6px;

  &.invalid {
    border-color: var(--error-color);
  }
}

#email,
#name {
  width: 100%;
  border: none;
  background: #ececec;
  border-radius: 17px;
  height: 34px;
  margin: 0;
  padding: 0 10px;
  margin-bottom: 25px;
  border: 1px solid #ececec;
  transition: border-color 0.25s;

  &.invalid {
    border-color: var(--error-color);
  }
}

label {
  float: none;
  display: block;
  padding: 0 0 7px 0;
}

.select-holder {
  margin-bottom: 20px;
}

button.secondary {
  margin-right: 5px;
}

.button-holder {
  height: 30px;
}
</style>
